import React from 'react';
import { SavingsGame } from '@/components/games/savings/SavingsGame';
import { GameLayout } from '@/components/layout/GameLayout';

export default function SavingsGamePage() {
  return (
    <GameLayout
      title="Ahorro Inteligente"
      description="Aprende estrategias básicas de ahorro y toma decisiones financieras"
    >
      <SavingsGame />
    </GameLayout>
  );
}
